var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.breadCrumbs,"prev":{name:'browse-space',params:{}}}}),_c('div',{staticClass:"rent-detail-container"},[(_vm.businessDetails)?_c('rent-details'):_vm._e(),(_vm.businessHistory)?_c('rent-history'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }